import { useMutation } from '@tanstack/react-query';
import { useUserState } from '../../hooks/context/useUserState';
import { requestConfig } from '../requests/requestConfig';
import { useLanguageSet } from './useLanguageSet';
import { SET_CONFIG } from '../../constants';

type getConfigArgs = {
  sessionToken: string;
};

export const useConfig = () => {
  const {
    state: { language },
    dispatch,
  } = useUserState();
  const { setLanguage } = useLanguageSet();

  const { error, mutateAsync: getConfig } = useMutation({
    mutationFn: ({ sessionToken }: getConfigArgs) =>
      requestConfig(sessionToken),
    onSuccess: async (response, variables) => {
      dispatch({ type: SET_CONFIG, payload: response });
      await setLanguage({
        language,
        sessionToken: variables.sessionToken,
        loggedIn: false,
      });
    },
  });

  return { error, getConfig };
};
